import {FormDialogComponent} from "../shared/dialog/form-dialog/form-dialog.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Component, Inject} from "@angular/core";
import {DialogComponentData} from "../shared/dialog/interfaces";
import {DialogService} from "../shared/dialog/dialog.service";
import {FormGroupManager} from "../shared/cml-forms/form-factory.service";
import {DialogComunicationService} from "../shared/dialog/dialog-comunication.service";
import {ValidationService} from "../shared/cml-forms/validation.service";
import {TypFormatu} from "../shared/enums/enums";


@Component({
    selector: 'ucetni-jednotka-form-service',
    templateUrl: '../shared/dialog/form-dialog/form-dialog.component.html',
    styleUrls: ['../shared/dialog/form-dialog/form-dialog.component.scss'],
    standalone: false
})
export class UcetniJednotkaDetailFormDialogService extends FormDialogComponent
{
  constructor(dialogService: DialogService,
              dialogRef: MatDialogRef<UcetniJednotkaDetailFormDialogService>,
              formManager: FormGroupManager,
              dialogComunicationService: DialogComunicationService,
              validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public override data: DialogComponentData)
  {
    super(dialogRef,data , dialogService, formManager, dialogComunicationService, validationService);
  }

  override async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.form.controls["exportUo"].valueChanges.subscribe(() => {
      this.changeSelects()
    });
  }

  private changeSelects(){
    const inpControl = this.form.controls["exportUo"]
    if (inpControl.value === false){
      this.form.controls["exportDokladoveRady"].setValue(false)
      this.form.controls["exportDokladoveRady"].disable()

      this.form.controls["exportUctovehoRozvrhu"].setValue(false)
      this.form.controls["exportUctovehoRozvrhu"].disable()
    }
    else {
      this.form.controls["exportDokladoveRady"].enable()
      this.form.controls["exportUctovehoRozvrhu"].enable()
    }
  }
}
